import { render, staticRenderFns } from "./TripUnClubbing.vue?vue&type=template&id=660fc1e2&scoped=true&"
import script from "./TripUnClubbing.vue?vue&type=script&lang=js&"
export * from "./TripUnClubbing.vue?vue&type=script&lang=js&"
import style0 from "./TripUnClubbing.vue?vue&type=style&index=0&id=660fc1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660fc1e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCard,VCheckbox})
